import { connect } from 'react-redux'

import { removeFolder } from '@chegg-wt/core/state/folders/actions'
import { DELETE_MODAL } from '@chegg-wt/core/state/modals/constants'

import { Dispatch } from 'redux'
import { AppState } from '@chegg-wt/core/state'
import { folderNameByIndexSelector } from '@chegg-wt/core/state/folders/selectors'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { DeleteModalBase } from './DeleteModalBase'

interface OwnProps {
  modalData: {
    index: number // TODO: Replace with meLinks/ids from data instead of using indexes of arrays
  }
}

const mapStateToProps = (state: AppState, ownProps: OwnProps) => ({
  title: `Delete folder '${folderNameByIndexSelector(state, {
    index: ownProps.modalData.index,
  })}'`,
  description: `Don’t worry the ${CITATION_LIST_NAME_LOWER_PLURAL} in this folder will not be deleted.`,
})

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  handleConfirm() {
    dispatch(removeFolder({ index: ownProps.modalData.index }))
  },
  handleClose() {
    dispatch(closeModal(DELETE_MODAL))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModalBase)
